import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, Row, Spin, Modal } from "antd";
import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  LoadingOutlined,
} from "@ant-design/icons";
import { authProject, removeItem, getItem } from "utils";

import { useHistory } from "react-router-dom";
import { authConfig, applyStyles } from "../../utils/auth";

import UnderMaintenance from "../../components/UnderMaintenance";

function Signin() {
  const [loading, setLoading] = useState(false);
  const [returnToken, setReturnToken] = useState(true);
  const [isUnderMaintenance, setIsUnderMaintenance] = useState(false);
  const [dns, setDns] = useState();
  const [visibleContact, setVisibleContact] = useState(false);

  const history = useHistory();

  async function onFinish(values) {
    setLoading(true);
    let { arg, password } = values;
    const mailformat =
      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (!arg.match(mailformat)) {
      arg = arg.replace(/\D/g, "");
    }
  }

  useEffect(() => {
    removeItem("tk-project");
    removeItem("tk-user");
    removeItem("userEmail");
    removeItem("userPhone");
    removeItem("userId");
    removeItem("privacyPolicy");
    removeItem("termsRepresentation");
    removeItem("termsConditions");
    removeItem("companyId");
    removeItem("androidAppUrl");
    removeItem("companyName");
    removeItem("iosAppUrl");

    var subdomain = window.location.hostname;

    if (window.location.hostname === "localhost") {
      subdomain = "brm1";
    } else {
      subdomain = subdomain.match(/embed-(.*?)\./)[1];
    }

    setDns(subdomain);

    applyStyles(subdomain).then(() =>
      authProject(authConfig).then(() => setReturnToken(false))
    );
  }, []);

  const colForm = {
    span: 12,
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
    className:
      "p-0 __auth-vh-100 d-flex flex-column justify-content-center align-items-center",
    style: { overflowX: "auto" },
  };

  const colImage = {
    span: 12,
    xs: 0,
    sm: 0,
    md: 0,
    lg: 12,
    className: "p-0 __auth-vh-100",
    style: {},
  };

  return (
    <>
      {isUnderMaintenance ? (
        <UnderMaintenance />
      ) : returnToken ? (
        <div className="d-flex vw-100 vh-100 align-items-center justify-content-center">
          <Spin tip="Carregando ambiente" spinning={returnToken} />
        </div>
      ) : (
        <Row className="__auth-background" align="middle" justify="center">
          <Col {...{ ...colForm }}>
            <Row align="middle" justify="center">
              <Col span={12}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <div className="__auth-main-logo-container">
                    <div className="main-logo"></div>
                  </div>
                </div>
              </Col>
            </Row>
            <Row align="middle" justify="center">
              <Col span={12} className="d-flex justify-content-center">
                <Form
                  layout={"vertical"}
                  initialValues={{
                    layout: "vertical",
                    remember: false,
                  }}
                  onFinish={onFinish}
                  requiredMark={false}
                  name="auth-signin"
                  className="__auth-form-signin"
                >
                  <div className="__auth-form-item">
                    <div className="__auth-form-label">
                      <label className="__auth-form-label">
                        E-mail ou CPF/CNPJ:
                      </label>
                    </div>
                    <Form.Item
                      name="arg"
                      type="email"
                      rules={[
                        {
                          required: true,
                          message: "Por favor, informe seu acesso",
                        },
                      ]}
                    >
                      <Input placeholder="Digite seu acesso" />
                    </Form.Item>
                  </div>
                  <div className="__auth-form-item">
                    <div className="__auth-form-label">
                      <label className="__auth-form-label">Senha:</label>
                    </div>
                    <Form.Item
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: "Por favor, informe sua senha",
                        },
                      ]}
                    >
                      <Input.Password
                        placeholder="Digite sua senha"
                        iconRender={(visible) =>
                          visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                        }
                      />
                    </Form.Item>
                  </div>
                  <Form.Item>
                    {/* <div className="__auth-resetpassword">
                      <a
                        onClick={() => history.push("/auth/resetPassword")}
                        className="__auth-m-sides-15 __auth-text-bold"
                      >
                        Esqueceu a senha?
                      </a>
                    </div> */}
                  </Form.Item>
                  <Form.Item>
                    <Button
                      className="ant-btn ant-btn-primary __auth-btn-signin"
                      type="primary"
                      htmlType="submit"
                      disabled={loading}
                      block
                    >
                      {loading ? <LoadingOutlined /> : "Entrar"}
                    </Button>
                  </Form.Item>

                  <div className="d-flex justify-content-center pb-5 __auth-terms-mobile">
                    <a
                      className="text-black"
                      onClick={() =>
                        getItem("termsConditions") &&
                        history.push(`/file/${dns}/termsConditions`)
                      }
                    >
                      Termos e condições
                    </a>
                    <span className="mx-2 text-black"> | </span>
                    <a
                      className="text-black"
                      onClick={
                        () =>
                          getItem("privacyPolicy") &&
                          history.push(`/file/${dns}/privacyPolicy`)
                        // window.open(getItem("privacyPolicy"))
                      }
                    >
                      Política de privacidade
                    </a>
                  </div>
                </Form>
              </Col>
            </Row>

            <button
              id="menu1"
              className="ant-btn ant-btn-primary"
              style={{ position: "absolute", bottom: "35px" }}
              onClick={() => setVisibleContact(true)}
            >
              Atendimento
            </button>
          </Col>
          <Col {...{ ...colImage }}>
            <div className="d-flex justify-content-end pb-4 __auth-signin-side-terms">
              <a
                className="text-white"
                onClick={() =>
                  getItem("termsConditions") &&
                  history.push(`/file/${dns}/termsConditions`)
                }
              >
                Termos e condições
              </a>
              <span className="mx-2 text-white"> | </span>
              <a
                className="text-white"
                onClick={
                  () =>
                    getItem("privacyPolicy") &&
                    history.push(`/file/${dns}/privacyPolicy`)
                  // window.open(getItem("privacyPolicy"))
                }
              >
                Política de privacidade
              </a>
            </div>
            <div className="__auth-signin-side __auth-vh-100"></div>
          </Col>

          <Modal
            title="Atendimento"
            visible={visibleContact}
            onOk={() => setVisibleContact(false)}
            okText={loading ? <LoadingOutlined /> : "Ok"}
            footer={null}
            onCancel={() => setVisibleContact(false)}
          >
            <h3>Dúvidas/Solicitações/Reclamações</h3>
            <p>Enviar e-mail para atendimento@sacbank.com.br</p>
            <p>Ouvidoria Atendimento Geral 11 48582547</p>
            <p>Ouvidoria 0800 111 4041</p>
            <p>WhatsApp 11 94801 4897</p>
          </Modal>
        </Row>
      )}
    </>
  );
}

export default Signin;
